<template>
  <a-modal
    :title="title"
    :width="500"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <div>
      <div>
        AadhaarName: {{ model.aadhaarName }}
      </div>
      <div>
        Application Amount:{{ model.applyAmt }}
      </div>
      <div>
        Term:{{ model.duration }}
      </div>
    </div>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
// import { addDict, editDict } from '@/webpublicapi/system'
export default {
  name: 'PendingModal',
  data () {
    return {
      value: 1,
      title: 'Action',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        dictName: { rules: [{ required: true, message: 'Please enterAadhaarName!' }] },
      }
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({})
    },
    edit (record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'aadhaarName', 'applyAmt', 'duration'))
      })
    },
    // Confirm
    handleOk () {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          values.aadhaarName = (values.aadhaarName || '').trim()
          const formData = Object.assign(this.model, values)
          let obj
          console.log(formData)
          // if (!this.model.id) {
          //   obj = addDict(formData)
          // } else {
          //    obj = editDict(formData)
          // }
          // obj.then((res) => {
          //   if (res.code === 1000) {
          //     that.$message.success(res.msg)
          //     that.$emit('ok')
          //   } else {
          //     that.$message.warning(res.msg)
          //   }
          // }).finally(() => {
          //   that.confirmLoading = false
          //   that.close()
          // })
        }
      })
    },
    // Close
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
